import React, { useEffect, useMemo } from "react";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../navigations/RootNavigation";
import PdfAssetViewer from "../components/PdfAssetViewer";
import { useI18n } from "../hooks/i18n-hooks";

type PdfViewerScreenProps = StackScreenProps<RootStackParamList, "PdfViewer">;

const PdfViewerScreen = ({ route, navigation }: PdfViewerScreenProps) => {
    const i18n = useI18n();
    const { title, assetId, filename } = useMemo(() => route.params, [route.params]);
    useEffect(() => {
        navigation.setOptions({
            title: title || "",
        });
    }, [navigation, title]);
    return (
        <PdfAssetViewer
            assetId={assetId}
            filename={filename}
            waitingDescription={i18n.t("loading")}
            scrollEnabled={true}
        />
    );
};

export default PdfViewerScreen;
